/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'CportalModule';
const componentName = 'cloud-widget';
const prefix = `${moduleName}.${componentName}`;

export const cloudServicesHeader = `${prefix}.cloudServicesHeader`;
export const portalUrlLabel = `${prefix}.portalUrlLabel`;
export const clusterNameLabel = `${prefix}.clusterNameLabel`;
export const siteIdLabel = `${prefix}.siteIdLabel`;
export const controllerRegisteredControllerBtnLabel = `${prefix}.controllerRegisteredControllerBtnLabel`;
export const connectToCloudServiceLabel = `${prefix}.connectToCloudServiceLabel`;
export const disconnectFromCloudServiceLabel = `${prefix}.disconnectFromCloudServiceLabel`;
export const cloudServicesRegisterControllerMessage = `${prefix}.cloudServicesRegisterControllerMessage`;
export const disconnectFromCloudServiceMessage = `${prefix}.disconnectFromCloudServiceMessage`;
export const cancelRegistrationLabel = `${prefix}.cancelRegistrationLabel`;
export const cancelRegistrationMessage = `${prefix}.cancelRegistrationMessage`;

export const ENGLISH = {
    [cloudServicesHeader]: 'Cloud Services',
    [clusterNameLabel]: 'Cluster Name',
    [portalUrlLabel]: 'Portal URL',
    [siteIdLabel]: 'Site ID',
    [controllerRegisteredControllerBtnLabel]: 'Complete Registration',
    [connectToCloudServiceLabel]: 'Connect to cloud service',
    [disconnectFromCloudServiceLabel]: 'Disconnect from cloud service',
    [cloudServicesRegisterControllerMessage]: 'Cloud Services must be connected for registering Controller.',
    [disconnectFromCloudServiceMessage]: 'This will disconnect you from Cloud Services.',
    [cancelRegistrationLabel]: 'Cancel Registration',
    [cancelRegistrationMessage]: 'This will cancel the in-progress registration and disconnect from Cloud Services.',
};
